export {};

declare global {
  interface Window {
    $RefreshReg$: () => void;
    $RefreshSig$: <T>() => (type: T) => T;
  }
}

if (typeof window !== 'undefined') {
  window.$RefreshReg$ = () => {};
  window.$RefreshSig$ = () => {
    return (type) => {
      return type;
    };
  };
}
